import { GET_PRODUCTS, ADD_PRODUCT, UPDATE_PRODUCT } from 'redux/actionTypes';

export default function products(state = [], action) {
    switch(action.type) {
        case GET_PRODUCTS:
            return [
                ...state,
                ...action.payload
            ];
        case ADD_PRODUCT:
            return [
                action.payload,
                ...state
            ];
        case UPDATE_PRODUCT:
            const index = state.findIndex(product => product.id === action.payload.id);
            return [
                ...state.slice(0, index),
                action.payload,
                ...state.slice(index + 1)
            ];
        default:
            return state;
    }
};